import React, { useEffect, useState } from "react";
import { AppPermissions, Lead, useHasPermission, useLead360 } from "../../../core";
import { useLeadActivities } from "../../../core/hooks/useLeadActivities";
import api from "../../../api";
import { ITabDetail, Tabcontroller } from "../../../core/components/tab-controller/tab-controller";
import { AddNoteActivity } from "./add-note-activity";
import { PlannedActivities } from "./planned-activities";
import { DoneActivities } from "./done-activities";
import { AddFileActivity } from "./add-file-activity";

interface ILeadActivitiesProps {
  addActivity?: () => void;
  leads: Lead[];
  id?: string;
  reloadActivity?: boolean;
  cssClass?: string;
  activityCategoryId?: string;
  activityCategory?: string;
  isCompany360?: boolean;
}

const Lead360Activities: React.FunctionComponent<ILeadActivitiesProps> = (
  props
) => {
  const { leadState, getLeadActivitiesAll } = useLeadActivities(api.lead);

  const leadIds = props.leads.map((l) => l._id!);
  const activityCategoryId = props.activityCategoryId || ''
  useEffect(() => {
    if (props.activityCategoryId && props.reloadActivity) {
      getLeadActivitiesAll([activityCategoryId!], props.activityCategory);
    }
  }, [props.reloadActivity]);

  useEffect(() => {
    if (props.activityCategoryId) {
      getLeadActivitiesAll([activityCategoryId!], props.activityCategory);
    } 
  }, []);

  const onSubmitCompleted = () => {
    if (props.activityCategoryId) {
      getLeadActivitiesAll([activityCategoryId!],props.activityCategory);
    } 
  };

  const plannedActivities = leadState.plannedActivities;
  const doneActivities = leadState.doneActivities;
  const [tabs, setTabs] = useState<ITabDetail[]>([
    {
      text: "Note",
      icon: "icon-note",
      isActive: true,
      content: (
        <AddNoteActivity 
          leads={props.leads}
          leadId={props.id!}
          onSubmitCompleted={onSubmitCompleted}
          activityCategoryId={props?.activityCategoryId}
          activityCategory={props.activityCategory}
        ></AddNoteActivity>
      ),
    },

    // // { text: 'Call', icon: 'icon-call', content: <div></div> },
    // // { text: 'Email', icon: 'icon-email', content: <div></div> },
    // // { text: 'Invoice', icon: 'icon-invoice', content: <div></div> },
    {
      text: "Files",
      icon: "icon-attach",
      content: (
        <AddFileActivity
          leads={props.leads}
          leadId={props.id}
          allActvity={true}
          activityCategoryId={props?.activityCategoryId}
          onSubmitCompleted={onSubmitCompleted}
          activityCategory={props.activityCategory}
        ></AddFileActivity>
      ),
    },
    // { text: 'Invoice', icon: 'icon-invoice', content: <div></div> },
  ]);

  return (
    <>
      <div className={`p-4 ${props.cssClass || ""}`}>
        {(<div className="bg-white border rounded position-relative">
            <div className="text-right addactity-btn px-3 position-absolute right-0" style={{ top : "8px"}}>
              <button
                type="button"
                onClick={() => props?.addActivity?.()}
                className="btn btn-link py-0 font-sm font-weight-semibold px-0 d-inline-flex align-items-center"
              >
                <i className="icon-plus mr-2 font-xs font-weight-bold"></i>{" "}
                Add Activity
              </button>
            </div>
            <Tabcontroller
              onChange={(index: number) => {
                const clone = [...tabs];
                clone.forEach((p, i) => {
                  i === index ? (p.isActive = true) : (p.isActive = false);
                });
              }}
              tabs={tabs}
            ></Tabcontroller>
          </div>
        )}

        <ul className={`activity-timeline list-unstyled mt-5 px-4 position-relative ${
            plannedActivities?.data?.length === 0 ? "hide-line" : ""
          }`}>
          <PlannedActivities
            addActivity={props.addActivity}
            leadIds={leadIds}
            activityDetails={plannedActivities}
            activityCategoryId={props?.activityCategoryId}
            activityCategory={props.activityCategory}
          ></PlannedActivities>
          <DoneActivities
            activityDetails={doneActivities}
            leadIds={leadIds}
            allActvity={true}
            activityCategoryId={activityCategoryId}
            activityCategory={props.activityCategory}
          ></DoneActivities>
        </ul>
      </div>
    </>
  );
};

export default Lead360Activities;
